import axios from 'axios';

export default {
  namespaced: true,

  state() {
    return {
      list: [],
      loaded: false,
      token: null,
      candidate_answers: new Map(),
      loading: false,
      error: null,
      canSave: false
    };
  },

  mutations: {
    set_list(state, v) {
      state.list = v;
    },

    set_token(state, v) {
      state.token = v;
    },

    set_loaded(state, v) {
      state.loaded = v;
    },

    set_loading(state, v) {
      state.loading = v;
    },

    set_error(state, v) {
      state.error = v;
    },

    set_answered(state, data) {
      // id, v
      let q = state.list.filter(i => i.id === data.id)[0];

      q.is_answered = data.v;
    },

    update_candidate_answers(state, data) {
      // id(вопроса), v
      if (!state.candidate_answers.has(data.id)) {
        state.candidate_answers.set(data.id, []);
        if (state.candidate_answers.size === state.list.length) {
          state.canSave = true;
        }
      }

      state.candidate_answers.set(data.id, data.v || []);
      if (state.candidate_answers.size === state.list.length) {
        state.canSave = true;
      }
    },

    clear_candidate_answers(state) {
      state.candidate_answers = new Map();
    }
  },

  actions: {
    async load({ commit, dispatch, state }) {
      let id = state.token;
      commit('set_loaded', false);

      return await axios.get(`1.0/interviews/${id}/tests/questions`).then(r => {
        commit('set_list', r.data.data);
        dispatch('questions/set_list', r.data.data, { root: true });
        commit('set_loaded', true);
      });
    },

    async save({ commit, state }, questionId) {
      commit('set_loading', true);
      let id = state.token;
      let question_answers = [];

      if (questionId === null) {
        state.list.forEach(x => {
          const candidateAnswersByQuestionId = state.candidate_answers.get(x.id);

          if (candidateAnswersByQuestionId !== undefined) {
            question_answers.push({ id: x.id, answers: candidateAnswersByQuestionId });
          } else {
            question_answers.push({ id: x.id, answers: [] });
          }
        });
        // Если questionId === null, то значит выбрано свойство показывать все вопросы на странице и нужно отправить все пустые вопросы где не было ответа
      } else if (questionId !== null && state.candidate_answers.size === 0) {
        question_answers = [{ id: questionId, answers: [] }];
      } else {
        question_answers = Array.from(state.candidate_answers.entries()).map(([key, value]) => ({
          id: key,
          answers: value
        }));
      }

      return await axios
        .put(`1.0/interviews/${id}/tests/questions`, { questions: question_answers })
        .then(r => {
          commit('set_error', null);
          return r;
        })
        .catch(err => {
          commit('set_error', err);
          return err;
        })
        .finally(() => {
          commit('clear_candidate_answers');
          commit('set_loading', false);
        });
    }
  },

  getters: {
    list(state) {
      return state.list;
    },
    token(state) {
      return state.token;
    },
    candidate_answers(state) {
      return state.candidate_answers;
    },
    current_opened_id(state) {
      return state.list.filter(i => i.is_answered === false && i.is_expired === false).map(i => i.id)[0];
    },
    loaded(state) {
      return state.loaded;
    },
    loading(state) {
      return state.loading;
    },
    canSave(state) {
      return state.canSave;
    }
  }
};
